// Copyright 2020 Sorama B.V.

import { Point3D } from "datatypes/SoramaWebApi";
import { URA } from "./URA";

export class ArrayProperties {
    constructor(
        public readonly isUra,
        public readonly width: number,
        public readonly height: number,
        public readonly spacing: number,
        public readonly maxSensorDistance: number
    ) {}
}

export function getArrayProperties(points: Point3D[]): ArrayProperties {
    // Check if ULA
    const ulaProps = URA.getUlaProperties(points);

    if (ulaProps.isUla) {
        return new ArrayProperties(
            true,
            ulaProps.length,
            0,
            ulaProps.spacing,
            ulaProps.lengthInElements * ulaProps.spacing
        );
    }

    // Check if URA
    const uraProps = URA.getUraProperties3D(points);

    if (uraProps.isUra) {
        return new ArrayProperties(
            true,
            uraProps.width,
            uraProps.height,
            uraProps.spacing,
            Math.sqrt(uraProps.width * uraProps.width + uraProps.height * uraProps.height)
        );
    }

    // Best effort do something else
    let endWidth = 0,
        endHeight = 0,
        maxLength = 0;
    let spacing = Number.MAX_VALUE;

    for (let i = 0; i < points.length; i++) {
        for (let j = 0; j < points.length; j++) {
            const x = points[i].x - points[j].x;
            const y = points[i].y - points[j].y;
            const z = points[i].z - points[j].z;

            endHeight = Math.max(endWidth, Math.abs(points[i].y - points[j].y));
            endWidth = Math.max(endWidth, Math.abs(points[i].x - points[j].x));
            spacing = Math.min(spacing, Math.sqrt(x * x + y * y + z * z));
            maxLength = Math.max(maxLength, Math.sqrt(x * x + y * y + z * z));
        }
    }

    return new ArrayProperties(false, endWidth, endHeight, spacing, maxLength);
}
